'use client'

import { useEffect, useState } from 'react'
import { createPortal } from 'react-dom'

import styles from './Overlay.module.scss'

export type OverlayProps = {
	onClick?: () => void
	isClosing?: boolean
}

export const Overlay = ({ onClick, isClosing }: OverlayProps): JSX.Element | null => {
	const [mounted, setMounted] = useState(false)

	useEffect(() => {
		setMounted(true)
	}, [])

	if (!mounted) return null

	return createPortal(
		<div className={`${styles.overlay} ${isClosing ? styles.out : styles.in}`} onClick={onClick} />,

		// Modals root
		document.getElementById('modals-root') as Element
	)
}
